﻿'use strict';

var
    notify = require('./notification'),
    validation = require('./validation');

function smtpSettingsInit() {
    $('#smtpMenuWindow').data('kendoWindow').center().open();
    $('#smtpMenuWindowNo, #smtpMenuClose').on('click', function () {
        $('#smtpMenuWindow').data('kendoWindow').destroy();
    });

    $('#smtpMenuWindowYes').on('click', onSmtpSettingSaveClick);

    $('.m-smtp-field').on('change', function () {
        smtpValidation();
    });
}

function onSmtpSettingSaveClick() {   
    $.ajax({
        data: {
            id: $('#SmtpId').val(),
            personId: $('#PersonId').val(),
            tenantId: $('#TenantId').val(),
            host: $('#m-host').val(),
            username: $('#m-username').val(),
            password: $('#m-password').val(),
            displayName: $('#m-displayName').val(),
            port: $('#m-port').val(),
            useSsl: $('#m-useSSL').prop('checked')
        },
        url: '/Account/UpdateSmtp',
        type: 'post',
        success: function (data) {
            if (data.error !== undefined) {
                notify.showErrorUpdateOnlyText(data.error, data.errorText);
            } else {
                $('#smtpMenuWindow').data('kendoWindow').destroy();
            }
        },
        error: function (data) {
            notify.showErrorUpdateOnlyText(data.error, data.errorText);
        }
    });
};

function smtpValidation() {
    var isValidForm = validation.validateForm($('#smtpSettingForm'), true);
    var isPortValid = validation.checkNumericNullCustom('#m-port');
    $('#smtpMenuWindowYes').data('kendoButton').enable(isValidForm && isPortValid);
}

module.exports = {
    smtpSettingsInit: smtpSettingsInit
};